import common from './en-US/common';
import country from './en-US/country';
import explore from './en-US/explore';
import login from './en-US/login';
import calendar from './en-US/calendar';
import feedback from './en-US/feedback';
import guide from './en-US/guide';
import navHeader from './en-US/navHeader';
import studio from './en-US/studio';
import urlCollection from './en-US/urlCollection';

export default {
  ...common,
  ...country,
  ...explore,
  ...login,
  ...calendar,
  ...feedback,
  ...guide,
  ...navHeader,
  ...studio,
  ...urlCollection,
};
